import React, { useState } from 'react';
import { Tabs } from 'antd';
import { connect } from 'react-redux';

import { Actions } from '../store/actions';
import Page from '../components/Page';
import PackageManagement from './packages/PackageManagement';
import PackagePostForm from './packages/PackagePostForm';

const Packages = ({ activeTabKey, updateActiveTab }) => {
	const handleClick = (key) => {
		updateActiveTab(key);
	};

	return (
		<Page title="Package Form Page" className="package-form-page">
			<Tabs onChange={handleClick} className="package-form-tabs" activeKey={activeTabKey} destroyInactiveTabPane={true}>
				<Tabs.TabPane tab="Packages Management" key="1">
					<PackageManagement />
				</Tabs.TabPane>
				<Tabs.TabPane tab="Add New Package" key="2">
					<PackagePostForm />
				</Tabs.TabPane>
			</Tabs>
		</Page>
	);
};

const mapStateToProps = (store) => ({
	activeTabKey: store.activeTabKey.activeTabKey,
});

const mapDispatchToProps = (dispatch) => ({
	updateActiveTab: (key) => dispatch(Actions.updateActiveTab(key)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Packages);
